import React, {useState} from 'react'
import css from './LoginV2Layout.module.scss'
import {UpsellGuruLogo} from 'usg-lib'

const backgroundImages = [
  'shutterstock_2491502837.jpg',
  'shutterstock_2547596115.jpg',
  'shutterstock_2573105089.jpg',
  'shutterstock_2447308359.jpg',
  'shutterstock_2602481479.jpg',
  'shutterstock_2441452589.jpg',
  'shutterstock_1477775297.jpg',
  'shutterstock_2601359643.jpg',
  'shutterstock_2533820601.jpg',
  'shutterstock_2548147313.jpg',
  'shutterstock_2570677329.jpg',
  'shutterstock_2542096685.jpg',
  'shutterstock_2542924649.jpg',
  'shutterstock_2597154983.jpg',
];

const LoginV2Layout = ({logo, children}) => {
  const [randomBackground] = useState(() => 
    backgroundImages[Math.floor(Math.random() * backgroundImages.length)]
  );

  return (
    <div className={css.pageV2}>
      <div className={css.content}>
        <div className={css.leftSection}>
          <div className={css.logo}>
            {logo ?
              <span dangerouslySetInnerHTML={{__html: logo}} /> :
              <UpsellGuruLogo width={200} />
            }
          </div>
          <div className={css.mainContent}>
            {children}
          </div>
        </div>
        <div
          className={css.rightSection}
          style={{
            backgroundImage: `url(https://d2n9rp3c1atvz5.cloudfront.net/sso/images/${randomBackground})`
          }}
        >
          <h2 className={css.bigTitle}>
            Smarter
            <div>Upselling</div>
          </h2>
        </div>
      </div>
    </div>
  )
}

export default LoginV2Layout
